import * as React from "react";
import { singleton } from "logic/singleton";
const SelectedIndexSetTemplateContext = React.createContext(void 0);
export default singleton("contexts.SelectedIndexSetTemplateContext", () => SelectedIndexSetTemplateContext);
